import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

/** Strip shown while previewing an unpublished finder. */
const PreviewBanner = () => {
  const { t } = useTranslation();

  return (
    <Box
      role="status"
      sx={{
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        textAlign: 'center',
        py: 1,
        px: 2,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {t('finder.preview_banner')}
      </Typography>
    </Box>
  );
};

export default PreviewBanner;
